import React from "react";
import "./TrackWorkshops.css";

const Track = (props) => {
    const pageLink = window.location.href.toString();
    const indexUtm = pageLink.indexOf('?');
    const utm = pageLink.slice(indexUtm + 1);

    return (
        <div className='w-track'>
            <p className="p1 w-tracksubTitle">Ticket + Workshop</p>
            <h3 className='w-trackTitle'>"{props.track.workshopTitle}"</h3>
            <div className='w-trackPrice'>
                <div className='w-track_prices'>
                    <p className='w-track_price p1'>ticket ${props.track.ticketPrice}</p>
                    <p className='w-track_price p1'>workshop ${props.track.workshopPrice}</p>
                </div>
                <div className='w-track_price-actual_block'>
                    <p className='w-track_price-actual'>${props.track.discountPrice}</p>
                    <p className='w-track_price-actual_desc'>together</p>
                </div>
                <div className='packages_price--save_block'>
                    <p className='packages_price--save_desc'>save</p>
                    <p className='packages_price--save'>${(+props.track.ticketPrice + +props.track.workshopPrice) - props.track.discountPrice}</p>
                </div>
            </div>
            <div className='w-track_info-block'>
                <div className='w-track_info'>
                    <p className='w-track_name p1'>{props.track.name}</p>
                    <p className='w-track_position p2'>{props.track.position}</p>
                    {props.track.logo && <img src={props.track.logo} className='w-track_logo' alt="" />}
                </div>
                <img src={props.track.photo} className='w-track_photo' alt="" />
            </div>
            <a className='button w-track_btn' target='_blank' rel='noreferrer' href={`${props.track.workshopLink}?page=angular2${indexUtm !== -1 ? `&${utm}` : ''}`}>get offer</a>
        </div>
    );
};

export default Track;